import { injectable } from 'inversify';

import { FormatService } from '@vk-hr-tek/core/format';
import { Filter } from '@vk-hr-tek/core/filter';
import { renderTwoLineOptionEllipsis } from '@vk-hr-tek/ui/input';

import { AttorneyUser } from '@app/gen/attorneys';

@injectable()
export class AttorneysUsersMapper {
  constructor(private format: FormatService) {}

  processStatus(
    status: 'new' | 'signed' | 'expired' | 'revoking' | 'revoked' | 'canceled',
  ): { label: string; color: 'accent.text.warning' | 'text.light.tertirary' } {
    const labels = {
      new: 'На подписании',
      signed: 'Действующая',
      expired: 'Истекла',
      revoking: 'В процессе отзыва',
      revoked: 'Отозвана',
      canceled: 'Отключена',
    };

    return {
      label: labels[status],
      color: status === 'new' ? 'accent.text.warning' : 'text.light.tertirary',
    };
  }

  processUsers(users: AttorneyUser[]) {
    return users.map((user) => {
      const {
        id,
        full_name: fullName,
        snils,
        company,
        groups,
        attorneys,
      } = user;

      return {
        id,
        employee: {
          fullName,
          snils: this.format.toSnils(snils),
          company,
        },
        roles: {
          items: groups.join(', ') || '-',
          count: groups.length,
        },
        attorneys: {
          items: attorneys.map(
            ({
              id: attorneyId,
              issuer,
              status,
              valid_from: validFrom,
              valid_to: validTo,
              is_default: isDefault,
            }) => ({
              id: attorneyId,
              issuer,
              status: this.processStatus(status),
              activeFromTo: `${this.format.toDate(
                validFrom,
              )} - ${this.format.toDate(validTo)}`,
              isDefault,
            }),
          ),
          count: attorneys.length,
        },
        actions: {
          id,
        },
      };
    });
  }

  processFilters(filters: Filter[]) {
    return filters?.map((filter) => {
      if (filter.key === 'user_id' && filter.type === 'search') {
        return {
          ...filter,
          minInputValueLength: 3,
          renderOption: renderTwoLineOptionEllipsis,
        };
      }

      return filter;
    });
  }
}
